// Debug filter: only allow console logs that include "Works Archive" or originate from works-archive
(function(){
  const originalWarn = console.warn;
  const originalError = console.error;
  const pass = (args)=>{
    try {
      const msg = args && args.length ? String(args[0]) : '';
      if (msg.includes('Works Archive') || msg.includes('WA:') || msg.includes('Sticky Scroll更新:') || msg.includes('アイテム') || msg.includes('フレーム')) {
        return true;
      }
      // Fallback: check stack for works-archive.js
      const stack = new Error().stack || '';
      if (stack.includes('works-archive')) return true;
    } catch(_) {}
    return false;
  };
  console.warn = function(...args){ if (pass(args)) originalWarn.apply(console, args); };
  console.error = function(...args){ originalError.apply(console, args); };
})();
